import React from 'react';
/**
 * Display not found
 */
const NonFound = () => (
  <div role='status' aria-labelledby='ID2'>
    <div className='cb-loader-shimmer cb-loader-hero-band cb-loader-light cb-gray4-bg '>
      <div className='container cb-padding-top-72 cb-padding-bottom-72'>
        <div className='row'>
          <div className='col-xs-12 col-sm-8 offset-sm-2 col-xl-6 offset-xl-3'>
            <div className='display-flex justify-content-center flex-column' id='ID2'
              role='img' aria-label='Loading content...' data-cb-apricot='cb-loader'>
              <div className='cb-line-24 cb-line-xl-up-32' />
              <div className='cb-margin-top-16 cb-line-48 cb-line-xl-up-72 cb-line-xs-32' />
              <div className='cb-margin-top-32 cb-margin-md-top-48 cb-line-16' />
              <div className='cb-margin-top-16 cb-no-margin-xs-bottom cb-margin-sm-bottom-16 cb-margin-bottom-8 cb-line-16' />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);
export default NonFound;